import React from 'react';
import SlotComponent from '../../SlotComponent';
import { useConditionLayout } from '../hooks/useConditionLayout';

const ConditionLayoutContainer = ({ children }: any) => {
	const { conditionIsTrue, Then, Else, mzShowThen } = useConditionLayout();
	if (conditionIsTrue && mzShowThen !== false) {
		if (Then) {
			return <SlotComponent props={Then} />;
		}

		return <>{children}</>;
	}

	if (Else) {
		return <SlotComponent props={Else} />;
	}
	return null;
};

export default ConditionLayoutContainer;
